<template>
  <v-row justify="center">
    <!-- <alert
      :data="errorData"
      :active="activeAlert"
      :colorAlert="colorAlert"
      @dialog:change="eventdialog"
    /> -->
    <v-btn class="accent shadow-4 px-8" large rounded @click.stop="dialog = true">Añadir Cliente</v-btn>

    <v-dialog v-model="dialog" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Nuevo cliente externo
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre del cliente de PBXBerry" rules="required" v-slot="{ errors }">
                      <v-select
                        v-model="client_id"
                        :items="Clients"
                        :error-messages="errors"
                        :loading="isLoadingClients"
                        item-text="name"
                        item-value="id"
                        prepend-inner-icon="mdi-database"
                        label="Nombre del cliente de PBXBerry"
                        filled
                        rounded
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="nombre del cliente externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre del cliente externo"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IP Cliente Externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IP Cliente Externo"
                        name="ip"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="ip"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IPQA Cliente Externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IPQA Cliente Externo"
                        name="ip_qa"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="ip_qa"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="usuario" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="user_name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseña" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="secret"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="secret" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="eventdialog">Cancelar</v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(sendform)"
                >Añadir</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    vuescroll,
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoadingClients: true,
      showPassword: false,
      dialog: false,
      loading: false,
      client_id: null,
      name: "",
      ip: "",
      ip_qa: "",
      user_name: "",
      secret: "",
      // errorData: "",
      // activeAlert: false,
      // colorAlert: "",
    };
  },

  computed: {
    Clients() {
      return this.$store.getters["clients/GET_ALL_CLIENTS"];
    },
  },

  created() {
    this.GetClients();
  },

  methods: {
    resetform() {
      this.client_id = "";
      this.name = "";
      this.ip = "";
      this.ip_qa = "";
      this.user_name = "";
      this.secret = "";
    },

    async GetClients() {
      try {
        const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
        this.data = response.data;
        this.isLoadingClients = false;
      } catch (error) {
        console.log(error);
      }
    },

    async sendform() {
      try {
        this.loading = true;
        const enviar = {
          client_id: this.client_id,
          name: this.name,
          ip: this.ip,
          ip_qa: this.ip_qa,
          user_name: this.user_name,
          secret: this.secret,
        };
        const { message } = await this.$store.dispatch("clients/REGISTER_EXTERNAL_CLIENTS", enviar);

        this.$snotify.success(message, "¡Hecho!");
        // console.log(res);

        this.loading = false;
        this.eventdialog();
      } catch (error) {
        console.log(error);
        this.$snotify.error(error.response?.data?.error, "¡Error!");
        // this.errorData = error.response.data;
        // this.activeAlert = true;
        // this.colorAlert = "red";
        this.loading = false;
      }
    },
    eventdialog() {
      this.resetform();
      this.dialog = false;
    },
  },
};
</script>
